import { useState } from "react";
import styles from "./Navbar.module.css";
import { navLinks } from "../../data/nav";
import { useScrolledPast } from "../../hooks/useScrollReveal";
import logo from "../../assets/images/jalaram-ad-logo.png";

export function Navbar() {
  const scrolled = useScrolledPast(24);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
      <div className={`container ${styles.bar}`}>
        <a href="#top" className={styles.brand} aria-label="Jalaram Ad. — home">
          <img src={logo} alt="Jalaram Ad. — Indoor / Outdoor Advertising" className={styles.logo} />
        </a>

        <nav className={styles.links} aria-label="Primary">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        {/* <div className={styles.actions}>
          <a href="#contact" className={`btn btn-primary ${styles.ctaButton}`}>
            Let&rsquo;s Talk
          </a>
          <button
            type="button"
            className={styles.menuToggle}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              {menuOpen ? (
                <path d="M3 3l12 12M15 3L3 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              ) : (
                <path d="M2 5h14M2 9h14M2 13h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              )}
            </svg>
          </button>
        </div> */}
      </div>

      <nav
        id="mobile-menu"
        className={`${styles.mobileMenu} ${menuOpen ? styles.open : ""}`}
        aria-label="Mobile"
      >
        {navLinks.map((link) => (
          <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)}>
            {link.label}
          </a>
        ))}
        <a href="#contact" onClick={() => setMenuOpen(false)}>
          Let&rsquo;s Talk
        </a>
      </nav>
    </header>
  );
}
